import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LangPipe } from './lang.pipe';
import { RemoveHtmlTagsPipe } from './inner-html.pipe';



@NgModule({
  declarations: [
    LangPipe,
    RemoveHtmlTagsPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LangPipe,
    RemoveHtmlTagsPipe
  ]
})
export class PipesModule { }
